<template>
  <div class="correct-explain-page">
    <iframe src="https://docs.qq.com/doc/DV2NkRG9KT1ZQcGJU" width="100%" height="100%"></iframe>
  </div>
</template>

<script>
export default {
  created () {
    window.utils.documentSetTitle('批改说明');
    this.beforeunloadHandler();
    // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    // console.log(this.beforeunloadHandler(), 'this.beforeunloadHandler();');
    // window.onbeforeunload = (e) => {
    //   this.beforeunloadHandler();
    //   e.preventDefault();
    //   // return null;
    // };
  },
  destroyed() {
    // window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    // window.removeEventListener('unload', e => this.unloadHandler(e))
  },
  methods: {
    beforeunloadHandler() {
      var action = new Promise((resolve, reject) => {
        this.$confirm('<p>下次进行教师点评，是否为您自动打开批改说明页面？</p>', '', {
          confirmButtonText: '自动打开',
          cancelButtonText: '不自动打开',
          type: 'warning',
          showClose:false,
          closeOnClickModal:false,
          dangerouslyUseHTMLString:true,
          showCancelButton:true
        }).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
      });
      action.then(() => { this.setUserCorrectExplain(0); }).catch(() => { this.setUserCorrectExplain(1); });
    },
    setUserCorrectExplain(set_status) {
      this.$api.SETUSERCORRECTEXPLAIN({set_status}).then(res => {
        if (res.retcode == 0) {
          // window.close();
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .correct-explain-page {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/correct-explain/index.vue